import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class JsonConverterService {
  constructor() {}

  public convertFile(file, filename) {
    const count = (file.match(/TRCFMT/g) || []).length;

    const frameJson = {
      filename: filename,
      first_format: '',
      first_num_points: '',
      first_angles: '',
      first_eye_pos: '',
      first_type: '',
      second_format: '',
      second_num_points: '',
      second_angles: '',
      second_eye_pos: '',
      second_type: '',
      framecirc: '',
      framedbl: '',
      fcrv: '',
      framea: '',
      frameb: '',
      ztilt: '',
      trace_count: count,
      first_framepoints: {},
      second_framepoints: {},
      framepoints: {},
    };
    const newLines = file.split(/\r\n|\n/) || [];
    const frameTraces = [];
    let frameTrace = null;
    for (let i = 0; i < newLines.length; i++) {
      let line = newLines[i];
      if ((line.match(/TRCFMT/g) || []).length > 0) {
        frameTrace = {
          frame: this.purify(line, 'TRCFMT='),
          framepoints_items: [],
        };

        frameTraces.push(frameTrace);
      }
      if ((line.match(/R=/g) || []).length > 0) {
        const lineDetails = this.purify(line, 'R=');
        for (const trace of lineDetails) {
          if (!isNaN(parseFloat(trace)) && frameTrace) {
            frameTrace.framepoints_items.push({
              framepoint: (parseFloat(trace) / 100).toFixed(2),
            });
          }
        }
      }
      if ((line.match(/CIRC=/g) || []).length > 0) {
        const lineDetails = this.purify(line, 'CIRC=');
        frameJson.framecirc = lineDetails[0];
      }
      if ((line.match(/DBL=/g) || []).length > 0) {
        const lineDetails = this.purify(line, 'DBL=');
        frameJson.framedbl = lineDetails[0];
      }
      if ((line.match(/FCRV=/g) || []).length > 0) {
        const lineDetails = this.purify(line, 'FCRV=');
        frameJson.fcrv = lineDetails[0];
      }
      if ((line.match(/HBOX=/g) || []).length > 0) {
        const lineDetails = this.purify(line, 'HBOX=');
        frameJson.framea = lineDetails[0];
      }
      if ((line.match(/VBOX=/g) || []).length > 0) {
        const lineDetails = this.purify(line, 'VBOX=');
        frameJson.frameb = lineDetails[0];
      }
      if ((line.match(/ZTILT=/g) || []).length > 0) {
        const lineDetails = this.purify(line, 'ZTILT=');
        frameJson.ztilt = lineDetails[0];
      }
    }
    frameJson.first_framepoints = {
      framepoints_items: frameTraces[0].framepoints_items,
    };
    frameJson.first_format = frameTraces.length > 0 && frameTraces[0].frame.length > 0 ? frameTraces[0].frame[0] : '';
    frameJson.first_num_points =
      frameTraces.length > 0 && frameTraces[0].frame.length > 0 ? frameTraces[0].frame[1] : '';
    frameJson.first_angles = frameTraces.length > 0 && frameTraces[0].frame.length > 0 ? frameTraces[0].frame[2] : '';
    frameJson.first_eye_pos = frameTraces.length > 0 && frameTraces[0].frame.length > 0 ? frameTraces[0].frame[3] : '';
    frameJson.first_type = frameTraces.length > 0 && frameTraces[0].frame.length > 0 ? frameTraces[0].frame[4] : '';
    if (frameTraces.length === 1) {
      delete frameJson.second_angles;
      delete frameJson.second_eye_pos;
      delete frameJson.second_format;
      delete frameJson.second_framepoints;
      delete frameJson.second_num_points;
      delete frameJson.second_type;
      frameJson.framepoints = frameJson.first_framepoints;
      delete frameJson.first_framepoints;
      delete frameJson.ztilt;
      delete frameJson.fcrv;
    } else {
      delete frameJson.framepoints;
      frameJson.second_framepoints = {
        framepoints_items: frameTraces[1].framepoints_items,
      };
      frameJson.second_format =
        frameTraces.length > 1 && frameTraces[1].frame.length > 0 ? frameTraces[1].frame[0] : '';
      frameJson.second_num_points =
        frameTraces.length > 1 && frameTraces[1].frame.length > 0 ? frameTraces[1].frame[1] : '';
      frameJson.second_angles =
        frameTraces.length > 1 && frameTraces[1].frame.length > 0 ? frameTraces[1].frame[2] : '';
      frameJson.second_eye_pos =
        frameTraces.length > 1 && frameTraces[1].frame.length > 0 ? frameTraces[1].frame[3] : '';
      frameJson.second_type = frameTraces.length > 1 && frameTraces[1].frame.length > 0 ? frameTraces[1].frame[4] : '';
    }
    return frameJson;
  }

  private purify(line, value): Array<any> {
    return line.replace(value, '').split(';');
  }
}
